module.exports = __webpack_public_path__ + "img/irlEvent.2b77bd80.png";